import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { deleteActivity } from '../actions/activity';
import { deleteDeliverable } from '../actions/deliverable';
import { useDispatch } from 'react-redux';


const DeleteActivity = (props) => {

    const dispatch = useDispatch();

    const deleteItem = () => {
        if (props.deliverable) {
            dispatch(deleteDeliverable(props.item));
        } else {
            dispatch(deleteActivity(props.item));
        }
        props.onHide();

        if (props.hideParent) {
            props.hideParent();
        }
    }
    return (

        <Modal show={props.show} onHide={props.onHide} id="activity-modal-delete">

            <React.Fragment>
                <Modal.Header>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-8">
                            <div className="row mb-3">
                                <div className="col-12">
                                    Delete:
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    {props.item.name}?
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="row">
                                <div className="col-12">
                                    <Button variant="danger" onClick={deleteItem}>
                                        Delete
                                    </Button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <Button variant="secondary" onClick={props.onHide}>
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
            </React.Fragment>

        </Modal>
    );
}

export default DeleteActivity;
